import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Loader, Products, SectionTitle } from '../components';
import { fetchProducts } from '../redux/actions';

export default function ProductsPage() {
  const { products } = useSelector((state) => state);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchProducts());
  }, []);

  return (
    <>
      {products?.items ? (
        <div className="max-w-2xl mx-auto py-4 px-4 sm:py-4 sm:px-6 lg:max-w-7xl lg:px-8">
          <>
            {products?.items?.length > 0 ? (
              <>
                <SectionTitle label={`${products?.items?.length} product(s)`} />
                <Products products={products?.items} />
              </>
            ) : (
              <div className="py-6 font-bold text-xl">
                No product to display.
              </div>
            )}
          </>
        </div>
      ) : (
        <Loader />
      )}
    </>
  );
}
